import { FilterOperator } from './filter-operator';

export class FilterParam {
    constructor(private fieldName: string, private operator: FilterOperator, private value: any) {}

    toString(): string {
        return `${this.fieldName}[${this.operator.toString()}]=${this.value}`;
    }

    isEqual(fieldName: string, operator: FilterOperator, value: any): boolean {
        return this.fieldName === fieldName && this.operator === operator && this.value === value;
    }
}
